import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.TypeAssetClassStrategyOptionsSortEnum>
) {
  const { sort, filter } = params;

  const {
    vehicleTypeOptions: { items: data, total },
  } = await sdk.getListVehicleTypeEnumOptions(filterSortPage({ filter, sort }));

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { vehicleTypeEnum: data } = await sdk.getOneVehicleTypeEnum({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { vehicleTypeEnumMany: data } = await sdk.getManyVehicleTypeEnum({
    ids,
  });

  return {
    data,
  };
}

/*********************************************************************/
export const vehicleTypeEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
